// extracted by mini-css-extract-plugin
module.exports = {"title":"PanelTitle_title__1V7za"};